import { Ref, ref } from 'vue';

export default class Sort {
	public isDropdownActive: Ref<boolean> = ref(false);
	public sortButton = ref<HTMLElement>();

	public toggle(): void {
		this.isDropdownActive.value = !this.isDropdownActive.value;
		this.setSortContainerDimensions();
	}

	public mounted(): void {
		window.addEventListener('click', (e) => {
			if (e.target !== this.sortButton.value && this.isDropdownActive.value) {
				this.toggle();
			}
		});
	}

	private setSortContainerDimensions(): void {
		const sortContainerClass = document.querySelector('.SortContainer') as HTMLElement;

		if (!sortContainerClass || !this.sortButton.value) {
			return;
		}

		if (!this.isDropdownActive.value) {
			sortContainerClass.classList.remove('active');
			return;
		}

		sortContainerClass.classList.add('active');

		const viewportWidth = document.documentElement.clientWidth;

		const { top: buttonTopPos, right: buttonRightPos, height: buttonHeightInPx } = this.sortButton.value.getBoundingClientRect();

		const mainNavSection = document.querySelector('.HeaderContainer') as HTMLElement;
		const mainNavSectionHeightInPx = mainNavSection ? mainNavSection.getBoundingClientRect().height : 0;
		const buttonBottomPos = buttonTopPos + buttonHeightInPx;

		sortContainerClass.style.top = `${buttonBottomPos - mainNavSectionHeightInPx}px`;
		sortContainerClass.style.right = `${viewportWidth - buttonRightPos}px`;
	}
}
